import React from "react";
import InputSelect from "../../../../components/common/InputSelect";
import { Col } from "react-bootstrap";
import InputText from "../../../../components/common/InputText";

function GroupDataset({
  data_set,
  setFieldSheetData,
  field,
  index,
  dataKey,
  touched,
  handleBlur,
  handleChange,
  values,
  fieldSheetData,
  transformedArray,
  setFieldValue,
  errors
}) {

  const setCheckedValue = (setFieldValue, name, array) => {
    if (array.every(obj => !obj.checked)) {
      setFieldValue(name, '')
    } else {
      setFieldValue(name, 'checked')
    }
  }
  return (
    <Col md="6" key={dataKey}>

      {data_set.map((group, groupKey) => {
        if (group.content_type.value == "dropdown") {
          return (

            <div className="fieldSheetBox">
              <InputSelect
                controlId={field.name + groupKey}
                // label={group.label}
                placeholder={group.label}
                touched={touched[field.name + groupKey]}
                handleBlur={handleBlur}
                handleChange={(e) => {
                  handleChange(e);
                  let fieldSheetTextTemp = [...fieldSheetData];
                  fieldSheetTextTemp[index].fields[dataKey].data_set[
                    groupKey
                  ].value =
                    e.target.value;
                  setFieldSheetData(fieldSheetTextTemp);
                }}
                errorsField={errors[field.name + groupKey]}
                value={values[field.name + groupKey]}
                options={transformedArray(group.content_array)}
                readOnly={false}
              />
              <label className="fieldSheetLabel">{group.label}</label>
            </div>

          );
        }

        if (group.content_type.value == "checkbox") {
          return (
            <>
            
              <div className={data_set.length > 1 ? 'fieldSheetBox checkboxSheet' : 'fieldSheetBox '}>

                {group.content_array.length &&
                  group.content_array.map((check, checkKey) => {
                    return (
                      <div className="checkboxWrapper" key={checkKey}>
                        <input
                          type="checkbox"
                          name={field.name + `${check.label}${groupKey}${checkKey}`}
                          checked={values[field.name + `${check.label}${groupKey}${checkKey}`]}
                          onChange={(e) => {
                            setFieldValue(
                              field.name + `${check.label}${groupKey}${checkKey}`,
                              !!e.target.checked
                            );



                            let fieldSheetTextTemp = [...fieldSheetData];
                            fieldSheetTextTemp[index].fields[dataKey].data_set[
                              groupKey
                            ].content_array[checkKey].checked =
                              !!e.target.checked;
                            setFieldSheetData(fieldSheetTextTemp);
                            setCheckedValue(setFieldValue, field.name, group.content_array)
                          }}
                          touched={touched[field.name + `${check.label}${groupKey}${checkKey}`]}
                          handleBlur={handleBlur}
                          errorsField={errors[field.name + `${check.label}${groupKey}${checkKey}`]}
                        />
                        <label>{check.label}  </label>

                      </div>

                    );
                  })}

              </div>
              <div className={data_set.length > 1 ? 'fieldSheetBox checkboxSheet' : 'fieldSheetBox '}>{errors[field.name] && <p className="text-danger">{errors[field.name]}</p>}</div></>

          );
        }

        if (group.content_type.value == "text") {
          return (
            <div className={data_set.length > 1 ? 'fieldSheetBox checkboxSheet' : 'fieldSheetBox   '}>

              <InputText
                controlId={
                  field.name + groupKey
                }
                placeholder={
                  field.title
                }
                className="form-control"
                touched={
                  touched[
                  field.name + groupKey
                  ]
                }
                handleBlur={
                  handleBlur
                }
                handleChange={(
                  e
                ) => {
                  handleChange(
                    e
                  );
                  let fieldSheetTextTemp = [...fieldSheetData];
                  fieldSheetTextTemp[index].fields[dataKey].data_set[groupKey].value = e.target.value;
                  setFieldSheetData(
                    fieldSheetTextTemp
                  );
                }}
                errorsField={
                  errors[
                  field.name + groupKey
                  ]
                }
                value={
                  values[
                  field.name + groupKey
                  ]
                }
              />
              {/* <label>{group.label}</label> */}
            </div>)

        }
      })}
    </Col>
  );
}

export default GroupDataset;
